import { EmptyPrompt } from './EmptyPrompt';
export default EmptyPrompt;
